/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import styled, { css } from 'styled-components';
import fonts, { fontSizes } from '@coop/ole/styles/fonts';
import grid from '@coop/ole/styles/grid';
import { breakpointsPhablet } from 'src/utils/customBreakpoints';

const TIEMPOS_MEDIUM_FONT = 'TiemposHeadlineMedium,Arial,sans-serif';

export const Paragraph = styled.p`
  font: ${fonts.normal(fontSizes.body)};
  line-height: 24px;
  margin: 0;
`;

export const LinkTextCss = css`
  font: ${fonts.bold(fontSizes.body)};
  line-height: 20px;
  letter-spacing: 0.6px;
`;

// hero
export const H1 = styled.h1`
  font-family: ${TIEMPOS_MEDIUM_FONT};
  font-size: 48px;
  font-weight: normal;
  line-height: 56px;
  margin: 0;

  /* override Invision specs with designer decision */
  @media (min-width: ${grid.breakpoints.md}) {
    font-size: 72px;
    line-height: 76px;
  }
`;
// section headings in all caps, crisis title in footer, quote attribution
export const H2 = styled.h2`
  font-family: ${TIEMPOS_MEDIUM_FONT};
  font-size: 32px;
  font-weight: normal;
  line-height: 40px;
  margin: 0;

  @media (min-width: ${breakpointsPhablet}) {
    font-size: 40px;
    line-height: 48px;
  }
`;
// bold headings above paragraphs
export const H3 = styled.h3`
  font-family: ${TIEMPOS_MEDIUM_FONT};
  font-size: 24px;
  font-weight: normal;
  line-height: 32px;
  margin: 0;
`;
// serif quote and first sentence in assessments
export const Quote = styled.div`
  font-family: ${TIEMPOS_MEDIUM_FONT};
  font-size: 28px;
  font-weight: normal;
  line-height: 36px;
  letter-spacing: 0.2px;
`;
